import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/workspaces/detail'
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error'
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { workspaceId } = action;

    const response = yield call(axios.get, 
      `${config.API_URL}/workspace/${workspaceId}`,
      { headers: getLocalUser() }
    );

    yield put(fetchSuccess(response.data));
  } catch (error) {
    console.error('Workspace detail saga: Error occurred:', error);
    console.error('Workspace detail saga: Error response:', error?.response?.data);
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
